import { CompetenciaInput, DateInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import { SelectCategoria } from 'app/components/Select';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import { ContasPagarAction, useContasPagar } from 'app/main/contaspagar/store';
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

const PesquisaContaPagarForm = () => {
  const formikContext = useFormikContext();
  const { values, handleChange } = formikContext;

  const [state, dispatch] = useContasPagar();
  const { requestParams } = state;

  const _errors = {};

  useEffect(() => {
    const pesquisar = async () => {
      const filtroAvancadoFormatado = formatarFiltroAvancado(values);

      const filtro = {
        ...requestParams,
        ...filtroAvancadoFormatado,
        page: 0,
        query: requestParams.q,
      };

      ContasPagarAction.setFiltroAvancado(dispatch, values);
      ContasPagarAction.fecharModalCadastro(dispatch);
      ContasPagarAction.carregarRegistros(dispatch, requestParams, filtroAvancadoFormatado);
      ContasPagarAction.buscarSomatorio(dispatch, filtro);
    };

    pesquisar();
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const formatarFiltroAvancado = (values) => {
    const filtro = {
      categoriaId: values?.categoria?.id,
      contaId: values?.conta?.id,
      dataVencimentoPagamento: values?.dataVencimentoPagamento?.format('YYYY-MM-DD'),
      dataLiquidacao: values?.dataLiquidacao?.format('YYYY-MM-DD'),
      formaPagamento: values?.formaPagamento ? values?.formaPagamento : undefined,
      fornecedorId: values?.fornecedor?.id,
      mesCompetencia: values?.mesCompetencia?.format('YYYY-MM-DD'),
      situacao: values?.situacao ? values?.situacao : undefined,
      tipoConsultaConciliacao: 'NAO_CONCILIADOS',
      origemConciliacao: true,
    };

    ContasPagarAction.setFiltroAvancadoFormatado(dispatch, filtro);

    return filtro;
  };

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <SelectInput
          id="situacao"
          label="Situação"
          onChange={handleChange}
          value={values?.situacao}
          error={_errors?.situacao}
          touched={!!_errors?.situacao}
          options={[
            { id: 'ABERTA', title: 'Aberta' },
            { id: 'BAIXADA', title: 'Baixada' },
            { id: 'ABERTA_BAIXADA', title: 'Aberta e baixada' },
            { id: 'PARCIAL', title: 'Parcial' },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <DateInput
          fullWidth
          id="dataVencimentoPagamento"
          label="Data do vencimento/pagamento"
          value={values?.dataVencimentoPagamento}
          onChange={handleChange}
          //onBlur={handleBlur}
          error={!!_errors.dataVencimentoPagamento}
          helperText={_errors.dataVencimentoPagamento}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <DateInput
          fullWidth
          id="dataLiquidacao"
          label="Data da liquidação"
          value={values?.dataLiquidacao}
          onChange={handleChange}
          error={!!_errors.dataLiquidacao}
          helperText={_errors.dataLiquidacao}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <CompetenciaInput
          fullWidth
          //onBlur={handleBlur}
          id="mesCompetencia"
          label="Mês competência"
          value={values?.mesCompetencia}
          onChange={handleChange}
          touched={!!_errors.mesCompetencia}
          error={_errors.mesCompetencia}
          helperText={_errors.mesCompetencia}
          format="MM/YYYY"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
        <SelectInput
          id="formaPagamento"
          label="Forma de pagamento"
          onChange={handleChange}
          value={values?.formaPagamento}
          error={_errors?.formaPagamento}
          touched={!!_errors?.formaPagamento}
          options={[
            { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
            { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
            { id: 'CHEQUE', title: 'Cheque' },
            { id: 'DEBITO_AUTOMATICO', title: 'Débito automático' },
            { id: 'DEBITO_CONTA', title: 'Débito em conta' },
            { id: 'DOC', title: 'DOC' },
            { id: 'TED', title: 'TED' },
            { id: 'TRANSFERENCIA_BANCARIA', title: 'Transferência bancária' },
            { id: 'DINHEIRO', title: 'Dinheiro' },
            { id: 'BOLETO', title: 'Boleto' },
            { id: 'OUTRAS', title: 'Outras' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
        <SelectFornecedor
          handleChange={handleChange}
          fornecedor={values?.fornecedor}
          error={_errors.fornecedor}
          touched={!!_errors.fornecedor}
          autoFocus
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectCategoria
          id="categoria"
          label="Categoria"
          value={values?.categoria}
          onChange={handleChange}
          maxLength={100}
          natureza="DESPESA"
          touched={!!_errors.categoria}
          error={_errors.categoria}
        />
      </Grid>
    </Grid>
  );
};

export default PesquisaContaPagarForm;
